import axiosInstance from './axios/axiosConfig'
import { endpoints } from './axios/endpoints'

// The pages show a failed request's reason themselves (ErrorBanner), so the
// shared error toast is off. A write's success message is still toasted.
const quietError = { silentErrorToast: true }

/**
 * Trainer dashboard notifications (CommunicationManagementService
 * /comms/trainer-notifications, plus the audience count TMS serves).
 *
 * Every comms call answers `{ status, message, ... }`; the audience count
 * answers `{ status: true, count, total_active_trainers }`.
 */
const TrainerNotificationService = {
    /** Grade groups, regions and products a cohort can be built from. */
    audienceOptions: () =>
        axiosInstance.get(endpoints.trainerNotificationAudienceOptions, {
            silentToast: true,
            ...quietError,
        }),

    /** Every notification, newest first (`notifications`). */
    list: () =>
        axiosInstance.get(endpoints.trainerNotifications, {
            silentToast: true,
            ...quietError,
        }),

    /** One notification and its view / acknowledge report (`notification`, `report`). */
    get: (id) =>
        axiosInstance.get(endpoints.trainerNotification(id), {
            silentToast: true,
            ...quietError,
        }),

    /** Save as a draft or publish (`status`); answers `notification_id`. */
    create: (body) =>
        axiosInstance.post(endpoints.trainerNotifications, body, quietError),

    /** Change a draft; `status: PUBLISHED` publishes it. */
    update: (id, body) =>
        axiosInstance.put(endpoints.trainerNotification(id), body, quietError),

    /** End a published notification now. */
    deactivate: (id) =>
        axiosInstance.post(
            endpoints.trainerNotificationDeactivate(id),
            null,
            quietError
        ),

    /** Delete a draft. */
    remove: (id) =>
        axiosInstance.delete(endpoints.trainerNotification(id), quietError),

    /**
     * How many active trainers an audience reaches (helpers/
     * trainerNotifications audienceCountBody). Asked while the form is
     * edited, so it stays out of the full-screen loader and its toasts.
     */
    audienceCount: (body) =>
        axiosInstance.post(endpoints.trainerNotificationAudienceCount, body, {
            background: true,
            silentToast: true,
            silentErrorToast: true,
        }),
}

export default TrainerNotificationService
